const zIndexes = [0, 1, 5, 10, 50, 100];

export { zIndexes };
